module.exports = __webpack_public_path__ + "static/media/healthyeatingfirstlithoniamedicalcenter.acc4604b.jpg";